import React, { useState, useEffect } from 'react';
import Layout from '../../components/Layout';
import { useLanguage } from '../../context/LanguageContext';
import { useNavigate } from 'react-router-dom';

const API = process.env.REACT_APP_API_URL || 'https://agents.matix.one';

const ContractTemplates = () => {
  const { lang, t } = useLanguage();
  const f = t('fsm') || {};
  const isRTL = lang === 'ar';
  const navigate = useNavigate();

  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);

  const sectionSt = {
    backgroundColor: 'rgba(26, 32, 56, 0.8)', padding: '20px', borderRadius: '12px',
    marginBottom: '16px', border: '1px solid rgba(255, 255, 255, 0.1)'
  };

  useEffect(() => { fetchTemplates(); }, []);

  const fetchTemplates = async () => {
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`${API}/api/v1/fsm/contract-templates`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await res.json();
      if (data.success) setTemplates(data.data || []);
    } catch (err) { console.error(err); }
    finally { setLoading(false); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this template?')) return;
    try {
      const token = localStorage.getItem('token');
      await fetch(`${API}/api/v1/fsm/contract-templates/${id}`, {
        method: 'DELETE', headers: { 'Authorization': `Bearer ${token}` }
      });
      fetchTemplates();
    } catch (err) { console.error(err); }
  };

  return (
    <Layout>
      <div style={{ direction: isRTL ? 'rtl' : 'ltr', padding: '24px', color: '#f9fafb' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
          <div>
            <h1 style={{ margin: 0, fontSize: '24px', fontWeight: '700' }}>Contract Templates</h1>
            <p style={{ margin: '4px 0 0', color: '#9ca3af', fontSize: '14px' }}>Design and manage your contract PDF templates</p>
          </div>
          <button onClick={() => navigate('/fsm/contract-templates/new')}
            style={{ backgroundColor: '#007bff', color: 'white', border: 'none', borderRadius: '10px', padding: '12px 24px', fontSize: '15px', fontWeight: '600', cursor: 'pointer' }}>
            + New Template
          </button>
        </div>

        {loading ? (
          <div style={{ textAlign: 'center', padding: '40px', color: '#9ca3af' }}>Loading...</div>
        ) : templates.length === 0 ? (
          <div style={{ ...sectionSt, textAlign: 'center', padding: '60px' }}>
            <div style={{ fontSize: '48px', marginBottom: '16px' }}>📄</div>
            <div style={{ fontSize: '16px', color: '#9ca3af', marginBottom: '16px' }}>No templates yet</div>
            <button onClick={() => navigate('/fsm/contract-templates/new')}
              style={{ backgroundColor: '#007bff', color: 'white', border: 'none', borderRadius: '8px', padding: '10px 20px', cursor: 'pointer', fontSize: '14px' }}>
              Create Your First Template
            </button>
          </div>
        ) : (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: '16px' }}>
            {templates.map(tmpl => (
              <div key={tmpl.id} style={{
                ...sectionSt, cursor: 'pointer', transition: 'border 0.2s',
                position: 'relative'
              }}
                onClick={() => navigate(`/fsm/contract-templates/${tmpl.id}/edit`)}
                onMouseEnter={(e) => e.currentTarget.style.borderColor = 'rgba(0,123,255,0.5)'}
                onMouseLeave={(e) => e.currentTarget.style.borderColor = 'rgba(255,255,255,0.1)'}
              >
                {tmpl.is_default ? (
                  <span style={{
                    position: 'absolute', top: '12px', right: isRTL ? 'auto' : '12px', left: isRTL ? '12px' : 'auto',
                    backgroundColor: 'rgba(22,163,106,0.2)', color: '#4ade80', padding: '2px 10px',
                    borderRadius: '12px', fontSize: '11px', fontWeight: '600'
                  }}>Default</span>
                ) : null}

                <div style={{ fontSize: '32px', marginBottom: '12px' }}>📄</div>
                <h3 style={{ margin: '0 0 4px', fontSize: '16px', fontWeight: '600' }}>{tmpl.name}</h3>
                {tmpl.name_ar && <div style={{ color: '#9ca3af', fontSize: '13px', direction: 'rtl' }}>{tmpl.name_ar}</div>}

                <div style={{ display: 'flex', gap: '12px', marginTop: '12px', color: '#9ca3af', fontSize: '12px' }}>
                  <span style={{
                    padding: '2px 8px', borderRadius: '4px',
                    backgroundColor: tmpl.language === 'ar' ? 'rgba(217,119,6,0.2)' : 'rgba(37,99,235,0.2)',
                    color: tmpl.language === 'ar' ? '#fbbf24' : '#60a5fa'
                  }}>
                    {tmpl.language === 'ar' ? 'عربي' : 'English'}
                  </span>
                  <span>{tmpl.page_size} {tmpl.orientation}</span>
                </div>

                <div style={{ display: 'flex', gap: '8px', marginTop: '16px' }}>
                  <button onClick={(e) => { e.stopPropagation(); navigate(`/fsm/contract-templates/${tmpl.id}/edit`); }}
                    style={{ flex: 1, backgroundColor: 'transparent', color: '#60a5fa', border: '1px solid rgba(96,165,250,0.3)', borderRadius: '6px', padding: '8px', cursor: 'pointer', fontSize: '13px' }}>
                    Edit
                  </button>
                  <button onClick={(e) => { e.stopPropagation(); handleDelete(tmpl.id); }}
                    style={{ backgroundColor: 'transparent', color: '#f87171', border: '1px solid rgba(220,38,38,0.3)', borderRadius: '6px', padding: '8px 12px', cursor: 'pointer', fontSize: '13px' }}>
                    Delete
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </Layout>
  );
};

export default ContractTemplates;
